import {
    BRAND_PROFILES_REQUEST,
    BRAND_PROFILES_REQUEST_COMPLETED,
    BRAND_PROFILES_FILTER_MUTATE,
    BRAND_PROFILES_SUGGESTIONS,
    BRAND_PROFILES_CONNECTIONS,
} from "constants/action-types";

import { handleActions } from "redux-actions";
import { Set } from "immutable";

const initialState = {
    results: [],
    connections: Set(),
    connectionsLoaded: false,
    suggestions: [],
    isFetching: false,
    error: undefined,
    nextPage: undefined,
    hasMoreResults: false,
    filters: undefined,
};

const snackbarsReducer = handleActions(
    {
        [BRAND_PROFILES_FILTER_MUTATE]: (state, { payload }) =>
            Object.assign({}, state, {
                filters: payload,
            }),
        [BRAND_PROFILES_REQUEST]: (state, { meta }) => {
            return Object.assign({}, state, {
                results: meta.reset ? [] : state.results,
                isFetching: true,
                nextPage: undefined,
                hasMoreResults: false,
            });
        },
        [BRAND_PROFILES_REQUEST_COMPLETED]: (state, { payload, error, meta }) => {
            if (error) {
                return Object.assign({}, state, {
                    isFetching: false,
                    error: payload,
                    hasMoreResults: false,
                });
            } else {
                return Object.assign({}, state, {
                    results: meta.reset ? payload : state.results.concat(...payload),
                    nextPage: meta.next,
                    hasMoreResults: !!meta.next,
                    isFetching: false,
                });
            }
        },
        [BRAND_PROFILES_SUGGESTIONS]: (state, { payload }) => {
            return Object.assign({}, state, {
                suggestions: payload,
            });
        },
        [BRAND_PROFILES_CONNECTIONS]: (state, { payload }) => {
            return Object.assign({}, state, {
                connections: Set(payload),
                connectionsLoaded: true,
            });
        },
    },
    initialState,
);

export default snackbarsReducer;
